<template>
    <div>
        <div class="modal hide fade" id="modalProjectSale" tabindex="-1" role="dialog" aria-labelledby="modalProjectSale" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            Create Project
                        </h4>
                        <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button> -->
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group row">
                            <label for="project_name" class="col-sm-3 col-form-label text-left">Project Name</label>
                            <div class="col-sm-9">
                              <input type="text" v-model="project_name" class="form-control">
                            </div>
                          </div>
                          <div class="form-group row">
                            <label for="schedule_date" class="col-sm-3 col-form-label text-left">Schedule Date</label>
                            <div class="col-sm-9">
                                <datetime v-model="schedule_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime>
                            </div>
                          </div>
                          <div class="form-group row">
                            <label for="estimated_date" class="col-sm-3 col-form-label text-left">Estimate Date</label>
                            <div class="col-sm-9">
                                <datetime v-model="estimated_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime>
                            </div>
                          </div>
                          <div class="form-group row">
                            <label for="type_id" class="col-sm-3 col-form-label text-left">Type</label>
                            <div class="col-sm-9">
                              <select v-model="type_id" class="form-control">
                                <option v-for="t in projectTypeList" :key="t.id" :value="t.id">{{ t.name }}</option>
                              </select>
                            </div>
                          </div>
                          <div class="form-group row">
                            <label for="engineer_id" class="col-sm-3 col-form-label text-left">PIC</label>
                            <div class="col-sm-9">
                              <select v-model="engineer_id" class="form-control">
                                <option v-for="u in userAll" :key="u.id" :value="u.id">{{ u.name }}</option>
                              </select>
                            </div>
                          </div>

                        </div>
                      </div>
                      <hr>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger btn-sm pull-left"  data-dismiss="modal"><i class="fa fa-times"></i> Close</button>
                        <button type="button" class="btn btn-success btn-sm pull-right" @click="createProject"><i class="fa fa-save"></i> Save</button>
                    </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import Axios from 'axios'
import { getHeader, salesUrl } from '../../config'
import { mapState } from 'vuex'
export default {
  name: 'SaleProjectModal',
  props: ['sales'],
  data () {
    return {
      project_name: null,
      schedule_date: null,
      estimated_date: null,
      type_id: null,
      engineer_id: null
    }
  },
  mounted () {
    this.$store.dispatch('getProjectTypeList')
    this.$store.dispatch('getUserAll')
  },
  computed: {
    ...mapState({
      projectTypeList: state => state.projects.projectTypeList,
      userAll: state => state.users.userAll
    })
  },
  methods: {
    createProject: function () {
      var obj = {
        id: this.sales.id,
        project_name: this.project_name,
        schedule_date: this.schedule_date,
        estimated_date: this.estimated_date,
        type_id: this.type_id,
        engineer_id: this.engineer_id
      }
      console.log(obj)
      Axios.post(salesUrl + '/project', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    }
  }
}
</script>
